import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "itemRate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        editable: true
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.08,
        flex: 0.6,
        filter: true,
    },
    {
        field: "discount",
        headerName: "Discount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        editable: true
    },
    {
        field: "extraCharges",
        headerName: "Extra charges",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        editable: true
    },
    {
        field: "taxableAmt",
        headerName: "Taxable amount",
        minWidth: window.innerWidth * 0.08,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "taxAmt",
        headerName: "Tax Amount",
        minWidth: window.innerWidth * 0.08,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },

];

export const SalesInvoicePopup = (props) => {
    return (
        <ModalBasic
            id="sales-invoice"
            classParams="!w-[85%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Sales invoice details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Invoice no</label>
                        <TextInput type='text'
                            id='invoiceNo' name='invoiceNo'
                            value={props.salesObject.invoiceNo}
                            handleChange={(event) => props.handleChangeForWork(event, 'invoiceNo')}
                            className={props.validState?.error?.invoiceNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Invoice date</label>
                        <TextInput type='date'
                            id='invoiceDate' name='invoiceDate'
                            value={props.salesObject.invoiceDate}
                            handleChange={(event) => props.handleChangeForWork(event, 'invoiceDate')}
                            className={props.validState?.error?.invoiceDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Challan</label>
                        <MultiSelectDropdown
                            drpIdentity="Select challan"
                            options={props.challanList}
                            value={props.salesObject.idChallanInvoice ? props.challanList.find(x => x.value === props.salesObject.idChallanInvoice) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idChallanInvoice")
                            }
                            className={props.validState?.error?.idChallanInvoice !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>I_type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select Itype"
                            options={props.challanFromList}
                            value={props.salesObject.challanFrom ? props.challanFromList.find(x => x.value === props.salesObject.challanFrom) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "challanFrom")
                            }
                            className={props.validState?.error?.challanFrom !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Inv. type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select InvType"
                            options={props.invTypeList}
                            value={props.salesObject.challanType ? props.invTypeList.find(x => x.value === props.salesObject.challanType) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "challanType")
                            }
                            className={props.validState?.error?.challanType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select customer</label>
                        <MultiSelectDropdown
                            drpIdentity="Select customer"
                            options={props.partyAccountList}
                            value={props.salesObject.idVendor ? props.partyAccountList.find(x => x.value === props.salesObject.idVendor) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idVendor")
                            }
                            className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Delivery</label>
                        <MultiSelectDropdown
                            drpIdentity="Select delivery"
                            options={props.partyAccountList}
                            value={props.salesObject.idDelivery ? props.partyAccountList.find(x => x.value === props.salesObject.idDelivery) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idDelivery")
                            }
                            className={props.validState?.error?.idDelivery !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Account head</label>
                        <MultiSelectDropdown
                            drpIdentity="Select delivery"
                            options={props.accountHeadList}
                            value={props.salesObject.idAccountHead ? props.accountHeadList.find(x => x.value === props.salesObject.idAccountHead) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idAccountHead")
                            }
                            className={props.validState?.error?.idAccountHead !== undefined ? "error" : ""}
                            isDisabled={true}
                        />

                    </div>

                    <div className='input-outer grid grid-cols-6 gap-2.5 col-span-6'>
                        <div className='input-grp row-span-2 col-span-2'>
                            <label>Address</label>
                            <textarea rows={4}
                                id='customerAddress' name='customerAddress'
                                value={props.salesObject.customerAddress}
                                onChange={(event) => props.handleChangeForWork(event, 'customerAddress')}
                                className={`h-full ${props.validState?.error?.customerAddress !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='input-grp row-span-2 col-span-2'>
                            <label>Delivery address</label>
                            <textarea rows={4}
                                id='deliveryAddress' name='deliveryAddress'
                                value={props.salesObject.deliveryAddress}
                                onChange={(event) => props.handleChangeForWork(event, 'deliveryAddress')}
                                className={`h-full ${props.validState?.error?.deliveryAddress !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Order no</label>
                            <TextInput type='text'
                                id='orderNo' name='orderNo'
                                value={props.salesObject.orderNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'orderNo')}
                                className={props.validState?.error?.orderNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Order date</label>
                            <TextInput type='date'
                                id='orderDate' name='orderDate'
                                value={props.salesObject.orderDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'orderDate')}
                                className={props.validState?.error?.orderDate !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Challan no</label>
                            <TextInput type='text'
                                id='challanNo' name='challanNo'
                                value={props.salesObject.challanNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'challanNo')}
                                className={props.validState?.error?.challanNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Challan date</label>
                            <TextInput type='date'
                                id='challanDate' name='challanDate'
                                value={props.salesObject.challanDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'challanDate')}
                                className={props.validState?.error?.challanDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Destination</label>
                            <TextInput type='text'
                                id='destination' name='destination'
                                value={props.salesObject.destination}
                                handleChange={(event) => props.handleChangeForWork(event, 'destination')}
                                className={props.validState?.error?.destination !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Transporter</label>
                            <TextInput type='text'
                                id='transporter' name='transporter'
                                value={props.salesObject.transporter}
                                handleChange={(event) => props.handleChangeForWork(event, 'transporter')}
                                className={props.validState?.error?.transporter !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Vehicle no</label>
                            <TextInput type='text'
                                id='vehicleNo' name='vehicleNo'
                                value={props.salesObject.vehicleNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'vehicleNo')}
                                className={props.validState?.error?.vehicleNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>P. terms</label>
                            <MultiSelectDropdown
                                drpIdentity="Select pterms"
                                options={props.pTermsList}
                                value={props.salesObject.idTerms ? props.pTermsList.find(x => x.value === props.salesObject.idTerms) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idTerms")
                                }
                                className={props.validState?.error?.idTerms !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Due date</label>
                            <TextInput type='date'
                                id='dueDate' name='dueDate'
                                value={props.salesObject.dueDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'dueDate')}
                                className={props.validState?.error?.dueDate !== undefined ? "error" : ""}
                            />
                        </div>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Invoice item details</span>
                <div className="process-table h-[30vh] mt-[5px]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            headerHeight={65}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            onCellValueChanged={props.onCellValueChanged}
                            stopEditingWhenCellsLoseFocus={true}
                        // onCellValueChanged={(params) => {
                        //     const updatedData = [];
                        //     params.api.forEachNode((node) => {
                        //         updatedData.push(node.data);
                        //     });
                        //     props.calcualteItem(updatedData);
                        // }}
                        />
                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Amount details</span>
                    <div className='input-grp-outer grid grid-cols-5 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total quantity</label>
                            <TextInput type='number'
                                id='totalQty' name='totalQty'
                                value={props.salesObject.totalQty}
                                handleChange={(event) => props.handleChangeForWork(event, 'totalQty')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total amount</label>
                            <TextInput type='number'
                                id='totalAmt' name='totalAmt'
                                value={props.salesObject.totalAmt}
                                handleChange={(event) => props.handleChangeForWork(event, 'totalAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Extra charges</label>
                            <TextInput type='number'
                                id='extraCharges' name='extraCharges'
                                value={props.salesObject.extraCharges}
                                handleChange={(event) => props.handleChangeForWork(event, 'extraCharges')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Discount amount</label>
                            <TextInput type='number'
                                id='discount' name='discount'
                                value={props.salesObject.discount}
                                handleChange={(event) => props.handleChangeForWork(event, 'discount')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Tax amount</label>
                            <TextInput type='number'
                                id='taxAmt' name='taxAmt'
                                value={props.salesObject.taxAmt}
                                handleChange={(event) => props.handleChangeForWork(event, 'taxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Taxable amount</label>
                            <TextInput type='number'
                                id='taxableAmt' name='taxableAmt'
                                value={props.salesObject.taxableAmt}
                                handleChange={(event) => props.handleChangeForPayment(event, 'taxableAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total with tax</label>
                            <TextInput type='number'
                                id='totalTaxAmt' name='totalTaxAmt'
                                value={props.salesObject.totalTaxAmt}
                                handleChange={(event) => props.handleChangeForWork(event, 'totalTaxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>TCS charges (%)</label>
                            <TextInput type='number'
                                id='tcsCharges' name='tcsCharges'
                                value={props.salesObject.tcsCharges}
                                handleChange={(event) => props.handleChangeForWork(event, 'tcsCharges')}
                                className='bg-white'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>TCS amount</label>
                            <TextInput type='number'
                                id='tcsAmount' name='tcsAmount'
                                value={props.salesObject.tcsAmount}
                                handleChange={(event) => props.handleChangeForWork(event, 'tcsAmount')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Adjustable amount</label>
                            <TextInput type='number'
                                id='adjustableAmt' name='adjustableAmt'
                                value={props.salesObject.adjustableAmt}
                                handleChange={(event) => props.handleChangeForWork(event, 'adjustableAmt')}
                                className='font-semibold'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Final amount</label>
                            <TextInput type='number'
                                id='finalAmt' name='finalAmt'
                                value={props.salesObject.finalAmt}
                                handleChange={(event) => props.handleChangeForWork(event, 'finalAmt')}
                                disabled
                                className='font-semibold'
                            />
                        </div>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}